import { h, Host } from "@stencil/core";
export class Tabbar {
    constructor() {
        this.tabs = [];
    }
    renderTabButton(tab) {
        const { label } = tab;
        const selected = tab === this.selectedTab;
        return (h("a", { role: "tab", "aria-selected": selected ? 'true' : null, class: {
                'tab-btn': true,
                'tab-btn-selected': selected
            }, onClick: ev => {
                this.uvexTabbarClick.emit(tab);
                ev.preventDefault();
            } }, label && h("span", { class: "tab-btn-text" }, label)));
    }
    render() {
        return (h(Host, { key: 'a98a36b94d107a44bdbf262916c29bceac834a33', role: "tablist" }, this.tabs.map(tab => this.renderTabButton(tab)), h("div", { key: '7963260965ebe3dfbba0dc2b171e2e9fbc18caff', hidden: true }, h("slot", { key: '310852669c9e79e9ffd2e3c92128165a5ab27b33' }))));
    }
    static get is() { return "uvex-tabbar"; }
    static get properties() {
        return {
            "selectedTab": {
                "type": "any",
                "attribute": "selected-tab",
                "mutable": false,
                "complexType": {
                    "original": "HTMLUvexTabElement",
                    "resolved": "HTMLUvexTabElement",
                    "references": {
                        "HTMLUvexTabElement": {
                            "location": "global",
                            "id": "global::HTMLUvexTabElement"
                        }
                    }
                },
                "required": false,
                "optional": true,
                "docs": {
                    "tags": [],
                    "text": ""
                },
                "getter": false,
                "setter": false,
                "reflect": false
            },
            "tabs": {
                "type": "unknown",
                "attribute": "tabs",
                "mutable": false,
                "complexType": {
                    "original": "HTMLUvexTabElement[]",
                    "resolved": "HTMLUvexTabElement[]",
                    "references": {
                        "HTMLUvexTabElement": {
                            "location": "global",
                            "id": "global::HTMLUvexTabElement"
                        }
                    }
                },
                "required": false,
                "optional": false,
                "docs": {
                    "tags": [],
                    "text": ""
                },
                "getter": false,
                "setter": false,
                "defaultValue": "[]"
            }
        };
    }
    static get events() {
        return [{
                "method": "uvexTabbarClick",
                "name": "uvexTabbarClick",
                "bubbles": true,
                "cancelable": true,
                "composed": true,
                "docs": {
                    "tags": [],
                    "text": ""
                },
                "complexType": {
                    "original": "HTMLUvexTabElement",
                    "resolved": "HTMLUvexTabElement",
                    "references": {
                        "HTMLUvexTabElement": {
                            "location": "global",
                            "id": "global::HTMLUvexTabElement"
                        }
                    }
                }
            }];
    }
}
//# sourceMappingURL=tabbar.js.map
